export default __webpack_public_path__ + "static/media/notice.f0e94e89.jpg";